import { render, staticRenderFns } from "./AddKontoDataModal.vue?vue&type=template&id=450999d4&"
import script from "./AddKontoDataModal.vue?vue&type=script&lang=js&"
export * from "./AddKontoDataModal.vue?vue&type=script&lang=js&"
import style0 from "./AddKontoDataModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports